export enum StateOrderBy {
  NAME = 'name'
}
